import moment from "moment"
import "moment/locale/pt-br"

function createDateFormat(date, formatCurrentDate) {
  const currentDate = moment(date, formatCurrentDate)

  function getDate() {
    return currentDate
  }

  function getFullYear() {
    return currentDate.year()
  }

  function diff(date, formatReturn = "days") {
    return currentDate.diff(date, formatReturn)
  }

  function format(format) {
    return currentDate.format(format)
  }

  function isValid() {
    return currentDate.isValid()
  }

  function toNow(parameters) {
    return currentDate.toNow(parameters)
  }

  function endOf(parameters) {
    return currentDate.endOf(parameters)
  }

  function add(...parameters) {
    return currentDate.add(...parameters)
  }

  function toDate() {
    return currentDate.toDate()
  }

  function subtract(...parameters) {
    return currentDate.subtract(...parameters)
  }

  function utc() {
    return moment.utc(date).toDate()
  }

  function local() {
    return moment(utc()).local()
  }

  function isAfter(...parameters) {
    return currentDate.isAfter(...parameters)
  }

  function isBefore(...parameters) {
    return currentDate.isBefore(...parameters)
  }

  function timeAgo() {
    return currentDate.fromNow()
  }

  return {
    getDate,
    getFullYear,
    diff,
    format,
    isValid,
    toNow,
    endOf,
    add,
    toDate,
    subtract,
    utc,
    local,
    isAfter,
    isBefore,
    timeAgo
  }
}

export default createDateFormat
